import { registerMenu } from '../components/Menu'
import { registerTabs } from '../components/Tabs';

export function homePage() {
    registerMenu()
    registerTabs()
}
